'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('activate', {
        templateUrl: 'app/activate/activate.html',
        abstract: true
      })
      .state('activate.enter', {
        url: '/passwordreset?new&username&token',
        templateUrl: 'app/activate/activateEnter.html',
        controller: 'ActivateEnterCtrl',
        controllerAs: 'ace'
      })
      .state('activate.wait', {
        templateUrl: 'app/activate/activateWait.html',
        controller: 'ActivateWaitCtrl',
        controllerAs: 'acw'
      })
      .state('activate.success', {
        templateUrl: 'app/activate/activateSuccess.html',
        controller: 'ActivateSuccessFailCtrl',
        controllerAs: 'acs'
      })
      .state('activate.fail', {
        templateUrl: 'app/activate/activateFail.html',
        controller: 'ActivateSuccessFailCtrl',
        controllerAs: 'acf'
      });;
  });